import { http } from '../http';

export const getContactAutoCompleteServiceV2 = async (queryParameter) => {
  const url = '/users';
  const response = await http.get(url, {
    params: { name: queryParameter },
    baseURL: process.env.BFFV2_BASE_URL,
  });
  if (response?.status !== 200) {
    throw new Error("Can't get contact auto complete");
  }
  return response?.data || '';
};

export default {
  getContactAutoCompleteServiceV2,
};
